import { CoinbaseWalletSDK } from '@coinbase/wallet-sdk';
import MINTPAGELOGO from "./MINTPAGELOGO.png";
window.Buffer = window.Buffer || require('buffer').Buffer;

const APP_NAME = "Hydro Mint";
const APP_LOGO_URL = MINTPAGELOGO;
const DEFAULT_ETH_JSONRPC_URL = "https://rpc.ankr.com/eth";
const DEFAULT_CHAIN_ID = 1;
export const coinbaseWalletInstance = new CoinbaseWalletSDK({
  appName: APP_NAME,
  appLogoUrl: APP_LOGO_URL,
  darkMode: false,
});
// Initialize a Web3 Provider object
export const coinBaseEthereum = coinbaseWalletInstance.makeWeb3Provider(
  DEFAULT_ETH_JSONRPC_URL,
  DEFAULT_CHAIN_ID
);
